import * as types from '../actions/types.action';

const initialState = {
  submitting: false,
  success: false,
  error: null,
  needsNewUpload: false,
};

export default function invoiceRegistrationReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.SUBMIT_INVOICE_REGISTRATION_REQUESTED:
      return Object.assign({}, state, {
        submitting: true,
        success: false,
        error: null,
        needsNewUpload: false,
      });
    case types.SUBMIT_INVOICE_REGISTRATION_SUCCESS:
      return Object.assign({}, state, {
        submitting: false,
        success: true,
      });
    case types.SUBMIT_INVOICE_REGISTRATION_FAILED:
      return Object.assign({}, state, {
        submitting: false,
        error: action.error,
        needsNewUpload: !!action.needsNewUpload,
      });
    case types.SUBMIT_INVOICE_REGISTRATION_RESET:
      return initialState;
    default:
      return state;
  }
}
